export const formatHistoryVersion = (
  version: number | null | undefined
): string => {
  if (version == null) {
    return "Unversioned";
  }

  return `v${version}`;
};
